import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SearchResultsList.css';
import React, { useEffect, useRef, useState } from 'react';
import ListingItem from '../ListingItem';
import { getItemColor } from '../../utils/getItemColor';
import { paginate } from '../../utils/paginate';
import { moveObjectToFirstPlace } from '../../../../114_InteractiveMap/InteractiveMap';
var SearchResultsList = function SearchResultsList(_ref) {
  var params = _ref.params,
    hits = _ref.hits,
    analytics = _ref.analytics,
    defaultTypeValues = _ref.defaultTypeValues,
    activeListingItemId = _ref.activeListingItemId,
    rtl = _ref.rtl,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks,
    mainHitsPerPage = _ref.mainHitsPerPage,
    query = _ref.query;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var loaderRef = useRef(null);
  var canBeMoreLoaded = useRef(true);
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  React.useEffect(function () {
    setItems(paginate(hits, Number(mainHitsPerPage), 1));
  }, [hits]);
  React.useEffect(function () {
    canBeMoreLoaded.current = false;
    if (activeListingItemId) {
      setPage(1);
      var updatedListingHits = moveObjectToFirstPlace(hits, function (hit) {
        return hit.objectID === activeListingItemId;
      });
      setItems(paginate(updatedListingHits, Number(mainHitsPerPage), 1));
      setTimeout(function () {
        canBeMoreLoaded.current = true;
      }, 2000);
    }
  }, [activeListingItemId]);
  var fetchData = function fetchData() {
    if (isLoading) return;
    var itemsToCompare = hits;
    var newData = paginate(itemsToCompare, Number(mainHitsPerPage), page + 1);
    setItems([].concat(_toConsumableArray(items), _toConsumableArray(newData)));
    setIsLoading(false);
    setPage(function (prevIndex) {
      return prevIndex + 1;
    });
  };
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      var target = entries[0];
      if (target.isIntersecting) {
        var itemsToCompare = hits;
        if (items.length !== itemsToCompare.length) {
          if (canBeMoreLoaded.current) {
            fetchData();
          } else {
            setPage(1);
          }
        }
      }
    });
    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return function () {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [fetchData]);
  var renderItems = function renderItems() {
    if (items && items.length) {
      return items.map(function (hit, index) {
        return /*#__PURE__*/React.createElement(ListingItem, {
          rtl: rtl,
          key: "".concat(hit.objectID),
          item: hit,
          isActiveItem: activeListingItemId === hit.objectID,
          color: getItemColor(hit, defaultTypeValues),
          isCarousel: false,
          analytics: analytics,
          params: params,
          getActivePopupOnMap: getActivePopupOnMap,
          activeTopPicks: activeTopPicks,
          toggleActiveTopPicks: toggleActiveTopPicks,
          withHighlightText: true,
          searchString: query
        });
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("ul", {
    className: "results-list"
  }, renderItems(), /*#__PURE__*/React.createElement("div", {
    ref: loaderRef,
    style: {
      paddingBottom: '50px'
    }
  }))));
};
export default SearchResultsList;
var StyledContainer = function StyledContainer(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c170ga2w";
var ltrStyles = "lq25x3l";
var rtlStyles = "rapa45w";